module.exports = __webpack_public_path__ + "assets/img/552a-bt.svg";